import GenericRequest, { METHOD_POST } from '../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../shared/webservices/endpoint';

export class ContractorsOfContractorFilesTask extends GenericRequest {

    _request // ContractorsOfContractorFilesRequest

    constructor(request) {
        super(METHOD_POST, ApiEndpoints.CONTRACTORS_OF_CONTRACTOR_FILES);
        this._request = request;
    }

    overrideRequest() {
        return this._request.body();
    }
}



// WEBPACK FOOTER //
// ./src/app/documentary-library/list/webservices/list-contractors/ContractorsOfContractorFilesTask.js